<template>
  <div class="page-title">
    <div class="row">
      <div class="col-sm-6 col-12">
        <h2>Driver Tax Registrations</h2>
      </div>
    </div>
  </div>

  <div class="card height-equal-2">
    <div class="card-body">
      <p class="text-muted">
        Independent drivers with no GST/HST number on file, plus anyone with an open registration
        request.
      </p>
      <DataTable
          :ajax="{ url: queueUrl }"
          ref="queueTable" class="table-responsive display custom-datatable" :columns="columnDefinition"/>
    </div>
  </div>
</template>

<script setup>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import {zonedDateTime} from "../utility/DatatableRenderer";

DataTable.use(DataTablesCore);

const queueUrl = `/api/datatable/driver-tax-registrations`;

const onboardingStatusBadge = (data) => {
  if (!data) return '<span class="badge bg-secondary">Unknown</span>';
  const statusMap = {
    'NOT_STARTED': {class: 'bg-secondary', label: 'Not Started'},
    'IN_PROGRESS': {class: 'bg-warning', label: 'In Progress'},
    'PENDING_VERIFICATION': {class: 'bg-info', label: 'Pending Verification'},
    'COMPLETE': {class: 'bg-success', label: 'Complete'},
    'REJECTED': {class: 'bg-danger', label: 'Rejected'}
  };
  const status = statusMap[data] || {class: 'bg-secondary', label: data};
  return `<span class="badge ${status.class}">${status.label}</span>`;
};

const requestStatusBadge = (data) => {
  if (!data) return '<span class="badge bg-secondary">None</span>';
  const statusMap = {
    'SUBMITTED': {class: 'bg-warning', label: 'Submitted'},
    'IN_PROGRESS': {class: 'bg-info', label: 'In Progress'},
    'COMPLETED': {class: 'bg-success', label: 'Completed'},
    'REJECTED': {class: 'bg-danger', label: 'Rejected'},
    'SUPERSEDED': {class: 'bg-secondary', label: 'Superseded'}
  };
  const status = statusMap[data] || {class: 'bg-secondary', label: data};
  return `<span class="badge ${status.class}">${status.label}</span>`;
};

const columnDefinition = [
  {data: "driverName", title: "Driver"},
  {data: "email", title: "Email"},
  {data: "onboardingStatus", title: "Onboarding", render: onboardingStatusBadge},
  {data: "requestStatus", title: "Registration Request", render: requestStatusBadge},
  {data: "submittedOn", title: "Submitted", render: zonedDateTime},
  {
    title: 'Actions', orderable: false, searchable: false, render: (data, type, row) => {
      return `<a class="btn btn-outline-primary" href="/admin/independent-driver/${row.driverId}">
        <i class="iconly-Info-Circle icbr"></i> View Driver </a>`;
    }
  }
];
</script>
